import type { TagsSearchParams } from '@gyym/sdk'
import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'

export const useTags = (params?: TagsSearchParams) => {
  const client = useGyymClient()
  return useGyymSWR([client.user.tags.list, params])
}
